/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { FontAwesomeIcon, IconsSolid } from '@jkhy/vsg-design-system';
import moment from 'moment';
import React, { memo, useEffect, useState } from 'react';

export type Column = {
  title: string;
  field: string;
  cell?: (cellValue: string) => any;
  dataUI?: string;
}

type GridProps = {
  data: Array<Object>;
  columns: Array<Column>;
  dataUI: string;
  className?: string;
}

type GridHeaderProps = {
  columns: Array<Column>;
  order: SortType;
  sortColumn: string;
  handleSort: (field: string) => void;
}

type GridBodyProps = {
  data: Array<Object>;
  columns: Array<Column>;
}

type SortType = 'asc' | 'desc';

const Grid = (props: GridProps) => {
  const {
    data,
    columns,
    dataUI,
    className,
  } = props;

  const [gridData, setGridData] = useState<Array<Object>>([]);
  const [order, setOrder] = useState<SortType>();
  const [sortColumn, setSortColumn] = useState<string>();

  useEffect(() => {
    setGridData([...data]);
  }, [data]);

  const handleSort = (field: string) => {
    let sortedData: Array<Object>;

    if (order === 'asc') {
      sortedData = data.sort((a: any, b: any) => {
        if (a[field] === null) {
          return -1;
        }
        if (b[field] === null) {
          return 1;
        }
        // check field type is date
        if (moment(a[field]).isValid()) {
          return moment(a[field], 'YYYYMMDD').isBefore(moment(b[field], 'YYYYMMDD')) ? -1 : 1;
        }
        return a[field] < b[field] ? -1 : 1;
      });
    } else {
      sortedData = data.sort((a: any, b: any) => {
        if (a[field] === null) {
          return 1;
        }
        if (b[field] === null) {
          return -1;
        }
        // check field type is date
        if (moment(a[field]).isValid()) {
          return moment(a[field], 'YYYYMMDD').isAfter(moment(b[field], 'YYYYMMDD')) ? -1 : 1;
        }
        return a[field] > b[field] ? -1 : 1;
      });
    }

    setGridData([...sortedData]);
    setSortColumn(field);
    order === 'asc' ? setOrder('desc') : setOrder('asc');
  };

  return (
    <div className={className} data-ui={dataUI}>
      <table className={className}>
        <GridHeader columns={columns} handleSort={handleSort} order={order} sortColumn={sortColumn} />
        <GridBody columns={columns} data={gridData} />
      </table>
    </div>
  );
};

const GridHeader = memo((props: GridHeaderProps) => {
  const {
    columns, handleSort, order, sortColumn,
  } = props;

  return (
    <thead>
      <tr>
        {columns.map((c, key) => {
          return (
            <th key={key}>
              <p className="body2 text-nowrap">
                <strong
                  onClick={() => handleSort(c.field)}
                  style={{ cursor: 'pointer', }}
                >
                  {c.title}
                </strong>
                {sortColumn === c.field && (
                  <FontAwesomeIcon size="s" icon={order === 'asc' ? IconsSolid.faArrowAltDown : IconsSolid.faArrowAltUp} />
                )}
              </p>
            </th>
          );
        })}
      </tr>
    </thead>
  );
});

const GridBody = memo((props: GridBodyProps) => {
  const { data, columns, } = props;

  return (
    <tbody>
      {data.map((row: any, key) => {
        return (
          <tr key={key}>
            {columns.map((c: Column, i) => {
              if (c.cell) {
                return (
                  <td key={i}>
                    <p className="body2" data-ui={c.dataUI}>{c.cell(row[c.field])}</p>
                  </td>
                );
              }
              return (
                <td key={i}>
                  <p className="body2" data-ui={c.dataUI}>{row[c.field]}</p>
                </td>
              );
            })}
          </tr>
        );
      })}
    </tbody>
  );
});

export default Grid;
